import React from 'react';
import TopNavBar from '../components/common/TopNavBar';

const WeeklyReportPage = () => {
  return (
    <div className="min-h-screen ob-sky-voyager font-body text-hp-on-surface relative overflow-x-hidden hp-trail-pattern">
      <TopNavBar />

      <main className="max-w-[1280px] mx-auto bg-white shadow-[0px_8px_24px_rgba(94,46,26,0.08)] min-h-screen flex flex-col overflow-hidden mt-6 rounded-t-3xl">

        {/* SECTION 1: Report Header */}
        <header className="relative bg-gradient-to-br from-[#1E5C2E] to-[#2A6B30] pt-16 pb-20 px-6 md:px-12 overflow-hidden rounded-t-3xl">
          <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 5l5 10h-10l5-10zm-15 20l3 6h-6l3-6zm30 0l3 6h-6l3-6zM15 45l2 4h-4l2-4zm30 0l2 4h-4l2-4z' fill='%23ffffff' fill-opacity='0.15' fill-rule='evenodd'/%3E%3C/svg%3E")`
          }} />
          <div className="relative z-10 flex flex-col items-center text-center text-white">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mb-6 shadow-xl border-4 border-white/20">
              <span style={{ fontSize: 56 }}>🦉</span>
            </div>
            <h1 className="font-headline text-3xl md:text-4xl font-black tracking-tight mb-2 uppercase">Báo Cáo Học Tập</h1>
            <p className="text-lg md:text-xl opacity-90 mb-4">
              Học sinh: <span className="font-bold">Minh</span> · Level: <span className="font-bold">Flyers ✈️</span>
            </p>
            <div className="flex items-center gap-4 md:gap-6 mt-4 flex-wrap justify-center">
              <button className="flex items-center gap-2 bg-white/10 hover:bg-white/20 px-4 py-2 rounded-full transition-all border border-white/20 text-sm font-headline font-bold">
                <span className="material-symbols-outlined text-sm">chevron_left</span> Tuần trước
              </button>
              <div className="bg-white text-[#1E5C2E] px-6 py-2 rounded-full font-headline font-bold shadow-lg text-sm">
                Tuần 07/04 – 13/04/2026
              </div>
              <button className="flex items-center gap-2 bg-white/10 hover:bg-white/20 px-4 py-2 rounded-full transition-all border border-white/20 text-sm font-headline font-bold">
                Tuần sau <span className="material-symbols-outlined text-sm">chevron_right</span>
              </button>
            </div>
          </div>
          {/* Floating stars */}
          <div className="absolute top-10 left-20 animate-pulse text-[#E8A020] opacity-40">
            <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>star</span>
          </div>
          <div className="absolute bottom-10 right-20 animate-pulse text-[#E8A020] opacity-40">
            <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>star</span>
          </div>
        </header>

        {/* SECTION 2: Weekly Summary */}
        <section className="px-6 md:px-12 -mt-10 z-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { icon: 'check_circle', value: '12 bài', label: 'Hoàn thành', iconBg: 'bg-green-100', iconColor: 'text-[#2A6B30]' },
              { icon: 'timer', value: '45 phút', label: 'Luyện tập', iconBg: 'bg-blue-100', iconColor: 'text-blue-600' },
              { icon: 'workspace_premium', value: '+2 mới', label: 'Mastered mới', iconBg: 'bg-amber-100', iconColor: 'text-[#E8A020]' },
              { icon: 'local_fire_department', value: '5 ngày', label: 'Streak', iconBg: 'bg-orange-100', iconColor: 'text-orange-600' },
            ].map((s, i) => (
              <div key={i} className="bg-white p-5 md:p-6 rounded-2xl shadow-[0px_8px_24px_rgba(94,46,26,0.08)] flex flex-col items-center text-center hover:-translate-y-1 transition-transform">
                <div className={`w-12 h-12 ${s.iconBg} ${s.iconColor} rounded-full flex items-center justify-center mb-3`}>
                  <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>{s.icon}</span>
                </div>
                <div className="font-headline text-2xl md:text-3xl font-black text-[#3E2B1E]">{s.value}</div>
                <div className="text-sm text-[#3E2B1E]/60 font-medium">{s.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* SECTION 3 & 4: Strengths + Weaknesses */}
        <div className="px-6 md:px-12 py-10 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Strengths */}
          <section className="bg-green-50/50 rounded-3xl p-6 md:p-8 border border-green-100">
            <h2 className="font-headline text-xl md:text-2xl font-black text-[#1E5C2E] flex items-center gap-3 mb-6">
              <span className="material-symbols-outlined text-[#67A844]" style={{ fontVariationSettings: "'FILL' 1" }}>check_circle</span>
              Điểm mạnh của con
            </h2>
            <div className="space-y-6">
              {[
                { name: 'Matching (Listening Part 3)', score: 95, msg: 'Kỹ năng phân tích từ khóa và nối thông tin rất xuất sắc!' },
                { name: 'Animals (Vocabulary)', score: 85, msg: 'Con nhớ rất tốt các từ vựng về động vật hoang dã.' },
                { name: 'Comparatives (Grammar)', score: 90, msg: 'Sử dụng thành thạo cấu trúc so sánh hơn với tính từ ngắn.' },
              ].map((item, i) => (
                <div key={i}>
                  <div className="flex justify-between items-end mb-2">
                    <span className="font-bold text-[#3E2B1E] text-sm">{item.name}</span>
                    <span className="font-headline font-black text-[#67A844]">{item.score}%</span>
                  </div>
                  <div className="h-3 bg-white rounded-full overflow-hidden">
                    <div className="h-full bg-[#67A844] rounded-full transition-all duration-700" style={{ width: `${item.score}%` }} />
                  </div>
                  <p className="text-xs mt-2 text-[#3E2B1E]/70 italic">{item.msg}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Weaknesses */}
          <section className="bg-amber-50/50 rounded-3xl p-6 md:p-8 border border-amber-100">
            <h2 className="font-headline text-xl md:text-2xl font-black text-[#5C2E1A] flex items-center gap-3 mb-6">
              <span className="material-symbols-outlined text-[#E8A020]" style={{ fontVariationSettings: "'FILL' 1" }}>warning</span>
              Cần hỗ trợ thêm
            </h2>
            <div className="space-y-5">
              {[
                { name: 'Past Simple', score: 35, color: 'text-red-500', barColor: 'bg-red-400', tip: 'Cùng con đọc truyện ngắn tiếng Anh, chú ý động từ quá khứ.' },
                { name: 'Food & Drink', score: 40, color: 'text-orange-500', barColor: 'bg-orange-400', tip: 'Khi đi siêu thị, chỉ vào đồ ăn và hỏi con tiếng Anh.' },
                { name: 'Prepositions', score: 45, color: 'text-orange-500', barColor: 'bg-orange-400', tip: <>Chơi trò đặt đồ vật: <strong>Put the book ON the table.</strong></> },
              ].map((item, i) => (
                <div key={i} className="bg-white/60 p-4 rounded-2xl border border-amber-100/50">
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-bold text-[#3E2B1E] text-sm">{item.name}</span>
                    <span className={`font-headline font-black ${item.color}`}>{item.score}%</span>
                  </div>
                  <div className="h-2 bg-amber-100 rounded-full overflow-hidden">
                    <div className={`h-full ${item.barColor} rounded-full transition-all duration-700`} style={{ width: `${item.score}%` }} />
                  </div>
                  <div className="mt-3 flex gap-2">
                    <span className="material-symbols-outlined text-[#E8A020] text-sm flex-shrink-0 mt-0.5">lightbulb</span>
                    <p className="text-xs text-[#5C2E1A]/80 leading-relaxed">{item.tip}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* SECTION 5: Progress Comparison */}
        <section className="px-6 md:px-12 pb-10">
          <div className="bg-[#F8F6F0] rounded-3xl p-6 md:p-8">
            <h2 className="font-headline text-xl md:text-2xl font-black mb-6 text-center text-[#3E2B1E]">So sánh tiến độ học tập</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {[
                { label: 'Kỹ năng Nghe', prev: '65%', current: '72%', diff: '▲+7%', positive: true },
                { label: 'Kỹ năng Đọc & Viết', prev: '58%', current: '58%', diff: '── 0%', positive: false },
                { label: 'Tổng bài làm', prev: '8', current: '12', diff: '▲+4', positive: true },
              ].map((item, i) => (
                <div key={i} className="flex flex-col items-center bg-white p-6 rounded-2xl shadow-sm">
                  <span className="text-sm text-[#3E2B1E]/50 mb-2">{item.label}</span>
                  <div className="flex items-center gap-3">
                    <span className="text-[#3E2B1E]/40 line-through">{item.prev}</span>
                    <span className="material-symbols-outlined text-[#3E2B1E]/20">arrow_forward</span>
                    <span className={`font-headline text-2xl font-black ${item.positive ? 'text-[#67A844]' : 'text-[#3E2B1E]'}`}>{item.current}</span>
                  </div>
                  <span className={`text-xs font-bold mt-2 px-2 py-0.5 rounded-full ${item.positive ? 'text-[#67A844] bg-[#67A844]/10' : 'text-[#3E2B1E]/40 bg-[#3E2B1E]/5'}`}>
                    {item.diff}
                  </span>
                </div>
              ))}
            </div>
            <div className="mt-8 bg-green-100/50 p-4 rounded-xl flex items-center justify-center gap-2 border border-green-200">
              <span className="text-xl">🎉</span>
              <p className="font-bold text-[#1E5C2E]">Con có tiến bộ rõ rệt ở kỹ năng Nghe!</p>
            </div>
          </div>
        </section>

        {/* SECTION 6: Weekly Activity */}
        <section className="px-6 md:px-12 pb-10">
          <div className="bg-white border-2 border-[#F8F6F0] rounded-3xl p-6 md:p-8">
            <h2 className="font-headline text-xl font-black mb-8 flex items-center gap-2">
              <span className="material-symbols-outlined text-[#2A6B30]">calendar_today</span>
              Hoạt động trong tuần
            </h2>
            <div className="flex justify-between items-start mb-12">
              {[
                { day: 'T2', active: true, count: '3 bài', time: '15 phút' },
                { day: 'T3', active: true, count: '2 bài', time: '10 phút' },
                { day: 'T4', active: false },
                { day: 'T5', active: true, count: '4 bài', time: '20 phút' },
                { day: 'T6', active: true, count: '2 bài', time: '10 phút' },
                { day: 'T7', active: true, count: '3 bài', time: '15 phút' },
                { day: 'CN', active: false },
              ].map((d, i) => (
                <div key={i} className="flex flex-col items-center gap-3">
                  <span className="text-xs text-[#3E2B1E]/40">{d.day}</span>
                  {d.active ? (
                    <div className="w-10 h-10 rounded-full bg-[#67A844] flex items-center justify-center text-white shadow-lg shadow-[#67A844]/20">
                      <span className="material-symbols-outlined text-sm" style={{ fontVariationSettings: "'FILL' 1" }}>done</span>
                    </div>
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-[#F8F6F0] border-2 border-[#3E2B1E]/5 flex items-center justify-center text-[#3E2B1E]/10">
                      <span className="material-symbols-outlined text-sm">circle</span>
                    </div>
                  )}
                  {d.active ? (
                    <div className="text-center">
                      <div className="text-[10px] font-bold text-[#3E2B1E]">{d.count}</div>
                      <div className="text-[10px] text-[#3E2B1E]/50">{d.time}</div>
                    </div>
                  ) : (
                    <div className="text-[10px] text-[#3E2B1E]/20">Nghỉ ngơi</div>
                  )}
                </div>
              ))}
            </div>
            <div className="pt-8 border-t border-[#F8F6F0] flex justify-center gap-12">
              <div className="text-center">
                <div className="text-sm text-[#3E2B1E]/50">Trung bình</div>
                <div className="font-headline text-lg font-black text-[#3E2B1E]">2.4 bài/ngày</div>
              </div>
              <div className="text-center">
                <div className="text-sm text-[#3E2B1E]/50">Thời gian học</div>
                <div className="font-headline text-lg font-black text-[#3E2B1E]">9 phút/ngày</div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 7: AI Message */}
        <section className="px-6 md:px-12 pb-12">
          <div className="bg-[#F0EAD6] rounded-3xl p-6 md:p-8 relative overflow-hidden">
            <div className="flex items-start gap-6 relative z-10">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center shrink-0 shadow-sm" style={{ transform: 'rotate(3deg)' }}>
                <span style={{ fontSize: 40 }}>🦉</span>
              </div>
              <div className="flex-1">
                <h3 className="font-headline text-xl font-black text-[#5C2E1A] mb-3">Lời nhắn từ cố vấn HuPath</h3>
                <div className="text-[#3E2B1E]/80 leading-relaxed space-y-4 text-sm">
                  <p>Chào ba mẹ, tuần qua Minh đã có những bước tiến rất đáng khen ngợi, đặc biệt là ở kỹ năng Nghe. Con đã thể hiện sự tập trung cao độ khi làm các bài tập Matching, đạt tỉ lệ chính xác gần như tuyệt đối (95%).</p>
                  <p>Tuy nhiên, con đang gặp một chút khó khăn với các cấu trúc ở thì Quá khứ đơn (Past Simple). Đây là một phần ngữ pháp quan trọng trong lộ trình Flyers. Ba mẹ đừng quá lo lắng nhé, trong tuần tới, ứng dụng sẽ ưu tiên hiển thị các bài học ôn tập lại phần này dưới dạng trò chơi tương tác để con dễ tiếp thu hơn.</p>
                  <p>Tiếp tục duy trì streak 5 ngày này sẽ giúp con hình thành thói quen học tập bền vững. Chúc Minh và ba mẹ một tuần mới học tập thật vui vẻ!</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 8: Share Actions */}
        <footer className="mt-auto bg-[#3E2B1E] px-6 md:px-12 py-10 text-white flex flex-col items-center">
          <h3 className="font-headline text-lg font-black mb-6">Chia sẻ báo cáo cho gia đình</h3>
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <button className="bg-[#0068FF] hover:bg-[#0052CC] px-6 py-3 rounded-xl flex items-center gap-3 transition-all font-headline font-bold">
              <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>send</span>
              Gửi qua Zalo
            </button>
            <button className="bg-white text-[#3E2B1E] hover:bg-[#F0EAD6] px-6 py-3 rounded-xl flex items-center gap-3 transition-all font-headline font-bold">
              <span className="material-symbols-outlined">mail</span>
              Gửi Email
            </button>
            <button className="bg-white/10 hover:bg-white/20 border border-white/20 px-6 py-3 rounded-xl flex items-center gap-3 transition-all font-headline font-bold">
              <span className="material-symbols-outlined">link</span>
              Copy Link
            </button>
          </div>
          <div className="flex flex-col items-center gap-2">
            <code className="bg-white/5 px-4 py-2 rounded-lg text-sm border border-white/10 font-mono opacity-80">hupath.vn/report/abc123</code>
            <p className="text-[10px] text-white/40 uppercase tracking-widest font-bold">Ai có link đều xem được, không cần đăng nhập</p>
          </div>
        </footer>
      </main>

      {/* Background decorations */}
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[150px] bg-white/60 blur-[60px] rounded-[100%] pointer-events-none -z-10"></div>
    </div>
  );
};

export default WeeklyReportPage;
